export default {
  title: 'Shantia Law Firm',
  themeColor: '#e4601d',
  clientSecret: 'ls_cms_secret',
  apiPrefix: '/cms'
}
